import { GlobalStorage } from "@otto-ec/global-client-storage";

// Export Debug functionality to global namespace.
window.o_global = window.o_global || {};
window.o_global.Storage = window.o_global.Storage || GlobalStorage;
